<template>
  <div>
    <van-nav-bar title="农艺">
        <!-- <div slot="left" style="color:#fff">
          <van-icon name="location-o" />
            {{phonePosition.lon}},{{phonePosition.lat}}
        </div> -->
    </van-nav-bar>
    <van-cell v-show="this.token != false ? true:false" :title="agrNodeInfo.name" style="top:46px;z-index:99">
      <div class='right'>
        <van-icon name="apps-o" color='#0076bf' size='22' @click="changNodePopup" style="float:right;vertical-align: middle;margin-left:15px"/>                
      </div>
    </van-cell>
    <div style="position:absolute;top:46px;bottom:0;left:0;right:0;overflow:auto;">
         <div id='agrMap'></div>
    <div class='cardBox'>      
      <van-row class="rowBox">
        <van-col span="12">
          <div class="card" @click="changeRoute('fertilizer')">
            <img style="background:#fff" src="../../assets/agronomy1.png" alt="">
            <div>
              <span>水肥方案</span>
            </div>
          </div> 
        </van-col>
        <van-col span="12">
          <div class="card" @click="changeRoute('plant')">
            <img style="background:#fff;border-radio" src="../../assets/agronomy4.png" alt="">
            <div>
              <span>植保方案</span>
            </div>
          </div> 
        </van-col>
        <van-col span="12">
          <div class="card" @click="changeRoute('gardening')">
            <img style="background:#fff" src="../../assets/agronomy3.png" alt="">
            <div>
              <span>园艺方案</span>
            </div>
          </div> 
        </van-col>
        <!-- <van-col span="12">
          <div class="card" @click="changeRoute('collection')">
            <img src="../../assets/agronomy2.png" alt="">
            <div>
              <span>我的收藏</span>
            </div>
          </div> 
        </van-col> -->
      </van-row>
    </div> 
    </div>
   


    <van-popup closeable  v-model="rListShow"  position="right" get-container="body"  :style="{ height: '100%',width:'80%' }">
        <div  style='height:65%;'>
        <van-cell-group title="基地列表">
          <van-search placeholder="请输入搜索关键词" @input='searchNode' v-model="searchText" />                        
        </van-cell-group>
        <div style='height:75%;overflow:auto'>
          <van-cell v-show="searchNodeList.length > 0 ? true : false"  @click="changNode(item)"   v-for="(item,index) in searchNodeList" :key="index"    :title="item.name"  >  
              <div v-if="item.name !=''" slot='default' :style="{color:item.is_login == 0?'#ee0a24':'#07c160'}">{{item.is_login == 0 ? '离线':'在线'}}</div>              
          </van-cell>
          <van-cell v-show="searchNodeList.length > 0 ? false : true">暂无该基地</van-cell>          
        </div>
      </div>
    </van-popup>
   
    
  </div>
</template>

<script>
// @ is an alias to /src
var argmap
import {getBaseList} from '@/request/data'
import { mapState,mapMutations } from 'vuex'
export default {
  name: 'agronomy',
  components: {
    
  },
  data() {
    return {
      rListShow:false,
      searchText:'',
      searchNodeList:[],
      nodeInfo:{
        nodeUuid:0,
        coordinate:'',
        isLogin:'',
      },
      nodeName:'',
      lat:'',
      lon:'',
    }
  },
  computed: {
    ...mapState(['phonePosition','token','agrNodeNameState','agrNodeInfo'])
  },
  mounted() {
    this.addMap()
    if (this.token) {
      this.getNodeList()
    }else{
      argmap.clearMap();
      this.lon = this.phonePosition.lon
      this.lat = this.phonePosition.lat
      let marker = new AMap.Marker({
          position: new AMap.LngLat(this.lon, this.lat),
        });
      argmap.setCenter([this.lon, this.lat]);
      marker.setMap(argmap);
      
    }
  },
  methods: {
    ...mapMutations(['setAgrNodeNameState','setAgrNodeInfo']),
    getNodeList(){
      getBaseList().then(res=>{
        this.nodeList = res.data.data.node
        this.searchNodeList = res.data.data.node
        let isLogin
        if (res.data.data.node[0].is_login) {
          isLogin ='在线'
        }else{
          isLogin ='离线'
        }
        if (this.agrNodeNameState) {
           this.nodeName = res.data.data.node[0].name
          this.nodeInfo.nodeUuid = res.data.data.node[0].uuid
          this.nodeInfo.coordinate = res.data.data.node[0].coordinate
          this.lon = this.nodeInfo.coordinate.split(',')[0]
          this.lat = this.nodeInfo.coordinate.split(',')[1]
          this.nodeInfo.isLogin = res.data.data.node[0].is_login
          argmap.clearMap();
          let marker = new AMap.Marker({
                position: new AMap.LngLat(this.lon, this.lat),               
            });
          argmap.setCenter([this.lon, this.lat]);
          marker.setMap(argmap);
          let data ={}
          data.name = res.data.data.node[0].name
          data.uuid = res.data.data.node[0].uuid
          data.coordinate = res.data.data.node[0].coordinate
          data.is_login = res.data.data.node[0].is_login
          this.setAgrNodeInfo(data)
          this.setAgrNodeNameState(false)
        }else{
          this.lon = this.agrNodeInfo.coordinate.split(',')[0]
          this.lat = this.agrNodeInfo.coordinate.split(',')[1]
          argmap.clearMap();
          let marker = new AMap.Marker({
                position: new AMap.LngLat(this.lon, this.lat),               
            });
          argmap.setCenter([this.lon, this.lat]);
          marker.setMap(argmap);
        }
       
      })
      
    },
    changeRoute(name){      
      switch (name) {
        case 'fertilizer':
          this.$router.push({name:'fertilizerPro',query:{uuid:this.nodeInfo.nodeUuid,lon:this.lon,lat:this.lat,type:1}});
          break;
        case 'plant':
            this.$router.push({name:'fertilizerPro',query:{uuid:this.nodeInfo.nodeUuid,lon:this.lon,lat:this.lat,type:2}});
          break;
        case 'gardening':
            this.$router.push({name:'fertilizerPro',query:{uuid:this.nodeInfo.nodeUuid,lon:this.lon,lat:this.lat,type:3}});
          break;
        case 'collection':
          this.$router.push({name:'collection'});
          break;
        default:
          break;
      }
    },
    searchNode(value){//搜索基地
        if (value == '') {
          this.searchNodeList = this.nodeList
        }else{
          this.searchNodeList = []          
          for (let i = 0; i < this.nodeList.length; i++) {
            if (this.nodeList[i].name.indexOf(value) >= 0) {
                this.searchNodeList.push(this.nodeList[i])
            }else{
                
            }
          }
        }
    },
    changNodePopup(){//选择基地列表弹出
      if (this.token) {
        this.searchNodeList = this.nodeList
        this.searchText = ''
        this.rListShow = true
      }else{
        this.$router.push({name:'login'})
      }
      
    },
    changNode(item){
        this.tabIndex = 0
        this.rListShow = false
        this.nodeName = item.name
        this.nodeInfo.nodeUuid = item.uuid
        this.nodeInfo.coordinate = item.coordinate
        this.lon = item.coordinate.split(',')[0]
        this.lat = item.coordinate.split(',')[1]
        argmap.clearMap();
        let marker = new AMap.Marker({
          position: new AMap.LngLat(this.lon, this.lat),
        });
        argmap.setCenter([this.lon, this.lat]);
        marker.setMap(argmap);

        
        this.nodeInfo.isLogin = item.is_login   
        let data ={}
        data.name = item.name
        data.uuid = item.uuid
        data.coordinate = item.coordinate
        data.is_login = item.is_login 
        this.setAgrNodeInfo(data)     
    },
    getPosition(){
      let _that = this
		  let sUserAgent = navigator.userAgent.toLowerCase();
		  let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
		  let bIsAndroid = sUserAgent.match(/android/i) == "android";		
		  let wx = sUserAgent.match(/MicroMessenger/i)=="micromessenger"
      
      if (this.token) {

      }else{

      }
        if (bIsIpad || bIsIphoneOs || bIsAndroid || wx) {
          // console.log('可以定位')
          //h5+定位
          this.mui.plusReady( () =>{				
            let map = new plus.maps.Map("map");
            map.getUserLocation( function ( state, point ){						
              if( 0 == state ){
                _that.lat = point.latitude
                _that.lon = point.longitude
                console.log(point.longitude,point.latitude)
              }else{
                _that.$toast('无法定位,请打开系统定位')
              }
            } );
          })
        }else{
          // console.log('不可以定位')
          this.$dialog.alert({ message: '为了您的定位正常,请使用微信打开' })
        }
    },
    addMap(){
      argmap = new AMap.Map('agrMap', {
          resizeEnable: true,          
          zoom: 14
      });     
    }
  },
}
</script>
<style scoped>
.cardBox{position: absolute;top: 240px;bottom: 50px;width: 100%;padding-bottom:50px}
.card img {width: 100%;}
.card{    display: inline-block;
    width: 80%; 
    height: 100%;
    margin: 0 auto;
    margin-bottom:30px;
    /* background-color: white; */
    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
    border-radius: 4px;    
    vertical-align: top;
}
.card span {
    text-align:center;
    font-size: 14px;
    color: #34495e;
    display: block;
    letter-spacing: 2px;
    line-height:36px    
}
.van-col--12{text-align:center}
.rowBox{margin-bottom:20px;}
#agrMap{height:150px;width:100%;margin-top:46px}
</style>